import {pushNotification} from '@malt/joy-v2/src/js/notification';

Hop.defineModule('showAlert', (root, param) => {
    const options = {};
    if (!param.message) {
        throw new Error('Missing message for your notification');
    }
    if (param.type) {
        options.level = param.type;
    }
    if (param.duration) {
        // Value in milliseconds !
        options.duration = param.duration;
    }

    pushNotification(param.message, options);
});
